import EpicCalendar from "./EpicCalendar";
export default EpicCalendar;
